import { createTheme } from "@mui/material";

const mainTheme = createTheme({
  palette: {
    primary: { main: "#4CAF50" },
    background: { default: "#F1F8F4" },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        fullWidth: true,
        size: "small",
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default mainTheme;